import React, { FC, ReactNode } from 'react';
import styles from '../journey-explorer.module.scss';
import { ExplorerView } from '../journey-explorer-utils';

const VIEWS: { view: ExplorerView; label: string }[] = [
	{ view: 'map', label: 'Map' },
	{ view: 'flow', label: 'Flow' },
	{ view: 'funnel', label: 'Funnel' },
	{ view: 'steps', label: 'Steps' },
];

interface ViewTabsProps {
	view: ExplorerView;
	descriptions: Record<ExplorerView, string>;
	onChange: (view: ExplorerView) => void;
	leading?: ReactNode;
	children?: ReactNode;
}

const ViewTabs: FC<ViewTabsProps> = ({ view, descriptions, onChange, leading, children }) => (
	<div className={styles.view_bar}>
		{leading}
		<div role="tablist" aria-label="Views" className={styles.segmented}>
			{VIEWS.map((item) => (
				<span key={item.view} className={styles.view_tab_wrap}>
					<button
						type="button"
						role="tab"
						aria-selected={view === item.view}
						aria-describedby={`journey-view-tip-${item.view}`}
						className={`${styles.segment} ${styles.view_tab} ${
							view === item.view ? styles.segment_active : ''
						}`}
						onClick={() => onChange(item.view)}
					>
						{item.label}
					</button>
					<span id={`journey-view-tip-${item.view}`} role="tooltip" className={styles.view_tip}>
						{descriptions[item.view]}
					</span>
				</span>
			))}
		</div>
		{children}
	</div>
);

export default ViewTabs;
